import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/hooks/use-auth";
import { AlertCircle } from "lucide-react";
import { useState } from "react";

interface LoginFormProps {
	onSuccess?: () => void;
}

export function LoginForm({ onSuccess }: LoginFormProps) {
	const [login, setLogin] = useState("");
	const [password, setPassword] = useState("");
	const { loginMutation } = useAuth();

	const handleSubmit = (e: React.FormEvent) => {
		e.preventDefault();
		if (!login.trim() || !password.trim()) return;

		loginMutation.mutate({ login: login.trim(), password }, { onSuccess: () => onSuccess?.() });
	};

	return (
		<form onSubmit={handleSubmit} className="w-full max-w-sm space-y-4">
			<div className="space-y-2">
				<label htmlFor="login" className="text-sm font-medium text-slate-700">
					Логин
				</label>
				<Input
					id="login"
					type="text"
					value={login}
					onChange={(e) => setLogin(e.target.value)}
					autoComplete="username"
					required
					disabled={loginMutation.isPending}
					placeholder="Введите логин"
				/>
			</div>

			<div className="space-y-2">
				<label htmlFor="password" className="text-sm font-medium text-slate-700">
					Пароль
				</label>
				<Input
					id="password"
					type="password"
					value={password}
					onChange={(e) => setPassword(e.target.value)}
					autoComplete="current-password"
					required
					disabled={loginMutation.isPending}
					placeholder="Введите пароль"
				/>
			</div>

			{loginMutation.isError && (
				<div className="flex items-start gap-2 rounded-md bg-red-50 p-3 text-sm text-red-700">
					<AlertCircle className="mt-0.5 h-4 w-4 flex-shrink-0" />
					<span>{loginMutation.error.message}</span>
				</div>
			)}

			<Button
				type="submit"
				disabled={loginMutation.isPending || !login.trim() || !password.trim()}
				className="w-full bg-blue-600 text-white hover:bg-blue-700"
			>
				{loginMutation.isPending ? "Вход..." : "Войти"}
			</Button>
		</form>
	);
}
